import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../types/types';
import { FORM_ASK_FOR } from './form-askfor-types';
import { getParameters } from '../../../helpers/helpers';

import { askForWidget, askForAvailWidget } from '../../widgets/askfor-widget';

import GetAskForQuestions from '../../../routes/get-askfor';
import GetCardGroupIndividual from '../../../routes/get-individual-card-group';

/**
 * Main function to display Ask For Question
 */
export const formAskFor = async () => {
  if ( !FORM_ASK_FOR.askForForm ) return;

  let cardgroupid = getParameters('cardGroupID');

  const [ cardGroup, askFor ] = await Promise.all([
    GetCardGroupIndividual(cardgroupid),
    GetAskForQuestions('', cardgroupid)
  ]);

  const { assigned, avalQues } = askFor.body;
  // @ts-ignore
  const { cardGroupName } = cardGroup[0];

  FORM_ASK_FOR.askForCardGroupText.value = cardGroupName;

  let linkedQuestions = avalQues.filter((item: any) => assigned.every((item2: any) => item2.askForId != item.askForId));

  const { askForResults, askForAvail } = FORM_ASK_FOR;
  askForWidget(assigned, askForResults);
  askForAvailWidget(linkedQuestions, askForAvail);

  removeSelectedQuestion(askForResults, askForAvail);
  addAvailQuestion(askForResults, askForAvail);

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');
}

/**
 * Selects and removed Ask For question from the associated container to the available container
 * 
 * @param {HTMLElement} associatedContainer the HTML element that has associated ask for questions
 * @param {HTMLElement} avalContainer the HTML element that has available ask for questions
 * 
 * @returns void
 */
const removeSelectedQuestion = (associatedContainer: HTMLElement, avalContainer: HTMLElement): void => {
  associatedContainer?.addEventListener('click' , e => {
    let data: object[] = [];
    const target = e.target as HTMLElement;

    if ( target != this && target.classList.contains('get-selected-element') ) {
      data.push({ askForId: target.dataset.askforid, askForText: target.dataset.askfortext, group: target.dataset.cardgroup });
      askForAvailWidget(data, avalContainer);
      target.parentElement!.parentElement!.remove();
    }
  });
}

/**
 * Adds Ask For question from the associated container to the associated container
 * 
 * @param {HTMLElement} associatedContainer the HTML element that has associated ask for questions
 * @param {HTMLElement} avalContainer the HTML element that has available ask for questions
 * 
 * @returns void
 */
const addAvailQuestion = (associatedContainer: HTMLElement, avalContainer: HTMLElement): void => {
  avalContainer?.addEventListener('click', e => {
    let data: object[] = [];
    const target = e.target as HTMLElement;

    let span = document.querySelectorAll<HTMLElement>('.title');

    if ( target != this && target.classList.contains('get-add-element')) {
      data.push({ askForId: target.dataset.askforid, askForText: target.dataset.askfortext, cardGroupID: target.dataset.cardgroup, sequence: span.length + 1, validate: 0 });
      askForWidget(data, associatedContainer);
      target.parentElement!.parentElement!.remove();
    }
  });
}
